import { Component, ElementRef, ViewChild } from '@angular/core';

import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

@CoreBuildingBlock('radio')
@Component({
  selector: 'cu-radio',
  templateUrl: './radio.component.html',
  standalone: false
})
export class RadioComponent extends CoreBuildingBlockControlBaseComponent {
  @ViewChild('radio') public radio: ElementRef;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public isArray(obj: any): boolean {
    return Array.isArray(obj);
  }

  public radioId(i): string {
    return `${this.field.id}-${i}`;
  }
}
